import parse from "html-react-parser";
import { createContext, Dispatch } from "react";
import { getChapters } from "./http/chapterApi";
import SVGDoc from "./icons/Doc.svg?react";
import SVGFile from "./icons/File.svg?react";
import SVGPdf from "./icons/Pdf.svg?react";
import SVGXls from "./icons/Xls.svg?react";
import {
  Chapter,
  IamUser,
  UserManagmentItem,
  UserRight,
} from "./types/apiTypes";
import { FileType } from "./types/types";

export const rightsMapping = new Map<UserRight, string>([
  ["admin", "Admin"],
  ["manager", "Manager"],
  ["secretary", "Sekretär"],
  ["member", "Mitglied"],
]);

export const formatText = (text: string) => {
  const newText = text.split("\n").join("<br>");
  return parse(newText);
};

export const buildUserLabel = (item: IamUser) =>
  item.email ? `${item.name} (${item.email})` : item.id;

export const buildFunctionaryLabel = (item: UserManagmentItem) =>
  item.person &&
  `${item.person.firstName} ${item.person.lastName} (${item.person.email})`;

export const setTitle = (chapter: Chapter) => {
  document.title = `HGV Ortsgruppenportal | ${chapter.name.replace(
    "HGV Ortsgruppe ",
    "",
  )}`;
};

export const getIcon = (type: FileType) => {
  switch (type) {
    case "dotx":
    case "docx":
      return SVGDoc;
    case "xltx":
    case "xlsx":
      return SVGXls;
    case "pdf":
      return SVGPdf;
    default:
      return SVGFile;
  }
};

const getStorageChapter = () => {
  const chapterString = localStorage.getItem("chapter");
  const id = parseInt(chapterString ?? "");
  return Number.isNaN(id) ? undefined : id;
};

const setStorageChapterId = (id: number | undefined) => {
  const chapterIdJSON = JSON.stringify(id);
  chapterIdJSON && localStorage.setItem("chapter", chapterIdJSON);
};

const setStorageChapter = (chapter: Chapter | undefined) => {
  setStorageChapterId(chapter?.id);
};

export const loadChapter = async () => {
  const storageChapterId = getStorageChapter();
  // TODO sort in API
  const chapters = (await getChapters())?.sort((a, b) =>
    a.name < b.name ? -1 : 1,
  );

  setStorageChapterId(storageChapterId ?? chapters?.[0]?.id);

  return chapters;
};

export const getSelectionChapter = (chapters: Chapter[] | undefined) => {
  const storageChapterId = getStorageChapter();

  const storageChapter = chapters
    ?.filter((chapter) => chapter.id === storageChapterId)
    .shift();

  if (!storageChapter) {
    setStorageChapter(chapters?.[0]);
    return chapters?.[0];
  }

  return storageChapter;
};

export const NotificationContext = createContext<Dispatch<any>>(() => {});

const padTo2Digits = (num: number) => num.toString().padStart(2, "0");

export const formatDate = (date: Date) =>
  [
    padTo2Digits(date.getDate()),
    padTo2Digits(date.getMonth() + 1),
    date.getFullYear(),
  ].join(".");
